"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = {}, action) => {
    if (action.editableUIState) {
        return Object.assign({}, action.editableUIState);
    }
    return state;
};
exports.getEditableUIState = (state) => state.editableUIState;
